import React, { Component } from "react";
import { TabPanel } from "devextreme-react";
import { connect } from "react-redux";
import MailingList from "components/AdminComponents/MailingList";
import SentMails from "components/AdminComponents/SentMails";
function mapStateToProps(state) {
  return {
    section: state.section,
  };
}
class Mails extends Component {
  constructor(props) {
    super(props);
    this.tabs = [
      {
        title: "Scheduled",
      },
      {
        title: "Sent",
      },
    ];
    this.component = (e) => {
      switch (e.data.title) {
        case "Scheduled":
          return <MailingList />;
        case "Sent":
          return <SentMails />;
        default:
          break;
      }
    };
  }
  componentDidMount() {
    this.props.dispatch({
      type: "SectionSelected",
      payload: "Seconday Stake",
    });
  }
  render() {
    return (
      <TabPanel
        dataSource={this.tabs}
        width={"100%"}
        itemComponent={this.component}
      />
    );
  }
}
export default connect(mapStateToProps)(Mails);
